import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import FleetPage from "@/pages/FleetPage";
import ContactPage from "@/pages/ContactPage";
import SingaporePage from "@/pages/SingaporePage";
import PrivateCharterPage from "@/pages/services/PrivateCharterPage";
import GroupCharterPage from "@/pages/services/GroupCharterPage";
import AirCargoPage from "@/pages/services/AirCargoPage";
import SpecialMissionsPage from "@/pages/services/SpecialMissionsPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/fleet" element={<FleetPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/singapore" element={<SingaporePage />} />
            <Route path="/services/private-charter" element={<PrivateCharterPage />} />
            <Route path="/services/group-charter" element={<GroupCharterPage />} />
            <Route path="/services/air-cargo" element={<AirCargoPage />} />
            <Route path="/services/special-missions" element={<SpecialMissionsPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>

      {/* 🔥 FLOATING WHATSAPP BUTTON */}
      <a
        href="https://wa.me/6581888023?text=Hi%20I%20am%20interested%20in%20your%20charter%20service"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50"
      >
        <img
          src="/w01.png"
          alt="WhatsApp"
    className="w-16 h-16 md:w-20 md:h-20 rounded-full shadow-2xl hover:scale-110 transition duration-300"
        />
      </a>
    </div>
  );
}

export default App;
